
import {Component, Vue} from 'vue-property-decorator';
import {nil} from '@/common';

@Component({
    components: {},
})
export default class ScreenSizeMixin extends Vue {
    public navbarHeight(): number {
        const nav = document.querySelector('.v-toolbar__content');
        if (nil(nav)) {
            return 0;
        }
        const h = Number(getComputedStyle(nav).height.replace('px', ''));
        return isNaN(h) ? 0 : h;
    }

    public sysbarHeight(): number {
        const sysbar = document.querySelector('#sysbar');
        if (nil(sysbar)) {
            return 0;
        }
        return sysbar.clientHeight;
    }

    public windowHeight(): number {
        /*console.log('getting window height');
        console.log(`window height : ${window.innerHeight}`);
        console.log(`navbarHeight ${this.navbarHeight()}`);
        console.log(`sysbarHeight ${this.sysbarHeight()}`);*/
        return (window.innerHeight - this.navbarHeight() - this.sysbarHeight());
    }

    public windowWidth(): number {
        return window.innerWidth;
    }
    public largestDimension(): number {
        const w = this.windowWidth();
        const h = this.windowHeight();
        return w > h ? w : h;
    }
}
